export {
    SignupPageTemplate,
    SignupPageTemplateBase,
    type SignupPageTemplateBaseProps
} from "./signup-page.template";
export { SignupPageTemplate as default } from "./signup-page.template";
